import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMinimize45: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconMinimize45"><Path fillRule="evenodd" clipRule="evenodd" d="M21.3108 3.75011L15.5608 9.50011H21.0001V11.0001H13.0001V3.00011H14.5001V8.43945L20.2501 2.68945L21.3108 3.75011ZM3.00011 13.0001H11.0001V21.0001H9.50011V15.5608L3.75011 21.3108L2.68945 20.2501L8.43945 14.5001H3.00011V13.0001Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMinimize45;
